import React from 'react';

import * as S from './MealWrapper.styled';

interface MealWrapperProps {
    image?: string;
    name?: string;
    difficulty?: string;
    cookingTime?: number;
    children?: React.ReactNode;
}

export const MealWrapper = ({ image, children }: MealWrapperProps) => (
    <S.Container data-locator="meal-details" data-testid="meal-details">
        <S.Image $image={image} />
        <S.Content>{children}</S.Content>
    </S.Container>
);
